import { LitElement, html, css } from 'lit';
import { accessibility, formStyles } from '../../utilities/styles';
import { editIcon, yellowTick, star } from '../../utilities/icons';
import { EventManager } from '../../utilities/events';
export class AllInPagedFormReview extends LitElement {
    static properties = {
        title: { type: String },
        formName: { type: String },
        pages: { type: Array },
        validate: { type: Boolean, reflect: true },
        uid: { type: String },
        hideUnchecked: { type: Boolean },
        hideEmpty: { type: Boolean },
        reviewPages: { type: Array, state: true },
        reviewSubPages: { type: Array, state: true }
    };
    constructor() {
        super();
        this.pages = [];
    }
    connectedCallback() {
        super.connectedCallback();
        this.eventManager = new EventManager(this);
    }
    async update(changedProperties) {
        if (changedProperties.has('pages')) {
            let pages = this.renderRoot.host.parentElement.querySelectorAll(`allin-paged-form-page`);
            await Promise.all(this.pages.map(async (page, i) => await pages[i].updateComplete));
            this.pages = this.pages.map((page, i) => {
                return {
                    ...page,
                    el: pages[i]
                };
            });
            await this.processPages();
        }
        super.update(changedProperties);
    }
    updated(changedProperties) {
        if (changedProperties.has('validate')) {
            if (this.validate) {
                this.eventManager.emit('allin-form-valid', { el: this.shadowRoot.host, validity: true });
                this.validate = false;
            }
        }
    }
    render() {
        let reviewPages = this.reviewPages?.map((page, i) => {
            if (!page)
                return '';
            let children = page.el.fields;
            let childrenMarkup = children.map((child) => {
                if (child.tagName == 'ALLIN-IMAGE-UPLOADER') {
                    let src = '';
                    if (child.img.dataset.has_src === "true") {
                        src = child.img.src;
                    }
                    else if (child.input.files.length && child.input.files[0].size > 0) {
                        src = URL.createObjectURL(child.input.files[0]);
                    }
                    let label = child.labelalt ?? child.label;
                    if (child.tablelabelalt) {
                        label = child.tablelabelalt ?? label;
                    }
                    if (src) {
                        return html `\n                            <tr class="field">\n                                <td>${label}</td>\n                                <td><img src="${src}" alt="file preview" /></td>\n                            </tr>\n                        `;
                    }
                    else {
                        let formData = JSON.parse(localStorage.getItem(`allin-paged-form-${this.formName}-${this.uid}`));
                        if (formData) {
                            let value = formData[child.inputname];
                            if (value) {
                                if (this.hideEmpty && !value.name) {
                                    return;
                                }
                                let label = child.labelalt ?? child.label;
                                if (child.tablelabelalt) {
                                    label = child.tablelabelalt ?? label;
                                }
                                return html `\n                                    <tr class="field">\n                                        <td>${label}</td>\n                                        <td>${value.name}</td>\n                                    </tr>\n                                `;
                            }
                        }
                        if (this.hideEmpty && !child.input.value) {
                            return;
                        }
                        return html `\n                            <tr class="field">\n                                <td>${child.labelalt ?? child.label}</td>\n                                <td>${child.input.value}</td>\n                            </tr>\n                        `;
                    }
                }
                else if (child.parentElement?.tagName == 'ALLIN-IMAGE-UPLOADER') {
                    return;
                }
                else {
                    if (child.dataset?.hide) {
                        return;
                    }
                    let label = '';
                    if (child.dataset?.label) {
                        label = child.dataset.label;
                    }
                    else if (child.labels?.length) {
                        label = child.labels[0].textContent;
                    }
                    if (!label) {
                        return;
                    }
                    let value = child.value;
                    if (child.dataset.no_review) {
                        return;
                    }
                    // detect PO / VAT fields
                    const isPOorVAT = label?.toLowerCase().includes('purchase order') || label?.toLowerCase().includes('vat');
                    if (child.type == 'checkbox') {
                        let forceShowReview = child.dataset.force_show_review === 'true';
                        if (this.hideUnchecked && !child.checked && !forceShowReview) {
                            return;
                        }
                        value = child.checked ? 'Yes' : 'No';
                    }
                    if (child.type == 'radio') {
                        if (!child.checked) {
                            return;
                        }
                        value = label;
                        label = child.parentElement.firstElementChild.dataset.label;
                    }
                    if (this.hideEmpty && !value) {
                        return;
                    }
                    // Add hyphen in place of empty value for PO and Vat Number
                    if (isPOorVAT && (!value || (typeof value === 'string' && value.trim() === ''))) {
                        value = '-';
                    }
                    if (child.type == 'hidden' && child.dataset.valuelabels) {
                        value = child.dataset.valuelabels;
                    }
                    if (child.type == 'file') {
                        if (child.files?.length) {
                            value = html `<img src="${URL.createObjectURL(child.files[0])}" alt="file preview" /><span>${child.files[0].name}</span>`;
                        }
                    }
                    if (child.tagName == 'SELECT') {
                        value = child.options[child.selectedIndex]?.textContent;
                    }
                    let isThisLast = false;
                    let isThisFirst = false;
                    let originalLabel = label;
                    if (child.id.includes('provision')) {
                        if (child.classList.contains('has_dependency')) {
                        }
                        else {
                            let provision_id = child.id.split('_')[2];
                            let allWithThisProvision = children.filter((child) => {
                                return child.id?.includes(provision_id) && child.value;
                            });
                            label = child.dataset.table_label ?? label;
                            isThisLast = allWithThisProvision[allWithThisProvision.length - 1].id == child.id;
                            isThisFirst = allWithThisProvision[0].id == child.id;
                        }
                    }
                    let firstTitle = '';
                    if (isThisFirst) {
                        firstTitle = html `<tr class="title_row"><td colspan="2"><h4>${originalLabel}</h4></td></tr>`;
                    }
                    return html `\n                        ${firstTitle}\n                        <tr class="field ${isThisLast ? 'last' : ''}">\n                            <td>${label}</td>\n                            <td>${value}</td>\n                        </tr>\n                    `;
                }
            });
            let isEmptyChildrenMarkup = childrenMarkup.filter((child) => child);
            if (isEmptyChildrenMarkup.length == 0) {
                childrenMarkup = html `<tr class="field"><td>You have not selected any provisions</td></tr>`;
            }
            return html `\n                <div class="review-page">\n                    <h3>${page.title}</h3>\n                    <div class="bg">\n                        <table>\n                            <thead class="screen-reader-text">\n                                <tr>\n                                    <th>Field</th>\n                                    <th>Value</th>\n                                </tr>\n                            </thead>\n                            <tbody>\n                                ${childrenMarkup}    \n                            </tbody>              \n                        </table>\n                        <hr>\n                        <a href="javascript:void(0)" data-page=${i} @click=${this._handleClick}>${editIcon}Edit these details</a>\n                    </div>\n                </div>\n            `;
        });
        let reviewSubPages = this.reviewSubPages?.map((subPages, i) => {
            if (!subPages)
                return '';
            let icons = {
                Preferred: star,
                Required: yellowTick
            };
            let childrenMarkup = subPages.map((subPage, j) => {
                let children = subPage?.fields;
                if (!children)
                    return '';
                let alerts = subPage._alerts?.map(a => a.cloneNode(true));
                let childMarkup = [];
                children.forEach((child) => {
                    if (child.value == 'not_needed' || !child.checked)
                        return;
                    let markup;
                    let label = child.dataset.label?.replace(/ ?- ?(Preferred|Required)$/i, '');
                    let state = icons[child.value] ?? '';
                    markup = html `<tr class="field preferred"><td><span class="${child.value} provisionstate">${state}<strong>${child.value}</strong></span></td><td>${label}</td></tr>`;
                    childMarkup.push(markup);
                });
                if (childMarkup.length == 0) {
                    return '';
                }
                return html `\n                    <div class="review-page subpageprovision">\n                        <div class="bg">\n                            <h4 class="h4">${subPage.title}</h4> \n                            ${alerts.length > 0 ? html `<div class="alerts">${alerts}</div>` : ''}\n                            <table>\n                                <thead class="screen-reader-text">\n                                    <tr>\n                                        <th>Required or Preferred</th>\n                                        <th>Provision</th>\n                                    </tr>\n                                </thead>\n                                <tbody>\n                                    ${childMarkup}    \n                                </tbody>              \n                            </table>\n                            <hr>\n                            <a href="javascript:void(0)" data-page=${i} data-subpage=${j} @click=${this._handleSubPageClick}>${editIcon}Edit these details</a>\n                        </div>\n                    </div>\n                `;
            });
            return html `${childrenMarkup}`;
        });
        return html ` \n            <div class="page">\n                ${reviewPages}\n                ${reviewSubPages}\n                <slot></slot>\n            </div>\n        `;
    }
    _handleClick(e) {
        let i = e.target.dataset.page;
        this.shadowRoot.host.parentElement.parentElement.changePage(i);
    }
    _handleSubPageClick(e) {
        let i = e.target.dataset.page;
        let j = e.target.dataset.subpage;
        console.log(j);
        this.shadowRoot.host.parentElement.parentElement.changePage(i);
        console.log(this.pages[i]);
        this.pages[i].el.setCurrentSubPage(j);
        //let subPage = this.reviewSubPages.flat().find(subPage=>subPage.fields.some(field=>field.id==`provision_${i}`));
    }
    setPages(pages) {
        this.pages = pages;
    }
    async processPages() {
        let reviewPages = this.pages?.map((page, i) => {
            if (page.el.isSubPageParent()) {
                return '';
            }
            if (page.el.isMasterPageParent()) {
                return '';
            }
            return page;
        });
        let reviewSubPages = await Promise.all(this.pages?.map(async (subPageParent) => {
            if (!subPageParent.el.isSubPageParent())
                return '';
            let children = await subPageParent.el.getSubPages();
            return children;
        }));
        this.reviewSubPages = reviewSubPages;
        this.reviewPages = reviewPages;
    }
    static styles = [
        accessibility,
        formStyles,
        css `
            .review-page{
                margin-bottom:3rem;
            }
            
            .review-page h3{
                color:var(--allin-secondary-color,#472961);
                margin-top:0;
            }

            .review-page .bg{
                background-color:var(--allin-bg-color,#E8E8E8);
                padding:var(--allin-padding,2rem);
                
            }

            table{
                width:100%;
                border-collapse:collapse;
            }
            tr.field{
                display:grid;
                gap:0.5rem;
                margin-bottom:1rem;
                padding-bottom:1rem;
                border-bottom:1px solid #ccc;
            }
            .field td:last-child{
                font-weight:600;
            }
            tr.field.last{
                border-bottom:1px solid #ccc;
                padding-bottom:1rem;
            }
            tr.field.last + tr.field td{
                padding-top:2rem;
            }
            tr.field.last:last-child{
                border-bottom:none;
            }
            @media (min-width: 768px){
                tr.field{
                    display:table-row;
                    margin-bottom:0;
                    padding-bottom:0;
                    border-bottom:none;
                }

                .field td:first-child{
                    width:40%;
                    padding-right:2rem;
                    vertical-align:top;
                }

                .field td:last-child{
                    width:60%;
                    font-weight:600;
                    vertical-align:top;
                }
                .field td{
                    padding-bottom:2rem;
                    overflow-wrap:break-word;
                }
            }
            
            .field td img{
                width:100px;
                height:100px;
                object-fit:contain;
                object-position:left;
            }
            .bg>a{
                font-weight:700;
                font-size:0.85rem;
                color:var(--allin-secondary-color,#472961);
                position:relative;
                display:inline-block;
                padding-left:1.2rem;
            }
            .bg>a svg{
                position:absolute;
                left:0;
                top:0;
                width:1rem;
                height:1rem;
            }
            .message{
                padding:1rem;
                border:1px solid var(--allin-secondary-color,#472961);
                display:grid;
                grid-template-columns: 2rem 1fr;
                gap:1rem;
                align-items: center;
                margin:1rem 0;
                background-color:#FFF;
                svg{
                    width:2rem;
                }
                a{
                    color:var(--allin-secondary-color,#472961);
                }
            }

            .subpageprovision{
                .subpageprovision td:first-child{

                }
                .provisionstate{
                    display:inline-flex;
                    align-items:center;
                    gap:0.25rem;
                    padding:0.2rem 0.3rem;
                    background-color:#FFF;
                    &>span{
                        padding:0.15rem;
                        width:1rem;
                        height:1rem;
                        display:inline-flex;
                        align-items:center;
                        justify-content:center;
                        border-radius:50%;
                    }
                }
                .Required>span{
                    background-color:var(--color-primary);
                    svg path{
                        fill:#000;
                    }
                }
                .field td:last-child{
                    font-weight:400;
                }
            }
            @media (min-width: 768px){
                .subpageprovision .field td:first-child{
                    width:15%;
                }
                .subpageprovision .field td:last-child{
                    width:85%;
                }
            }

        `
    ];
}
